import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#3f8cf2",
  boardColor: "#C2C2C2",
  cardColor: "white",
};
